import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'dynamic-search',
  templateUrl: './dynamic-search.component.html',
  styleUrls: ['./dynamic-search.component.css']
})
export class DynamicSearchComponent implements OnInit {
  @Input() submit;
  @Input() params;
  @Input() searchSettings;

  addSearch(field: { name: string, placeholder: string, isBoolean?: boolean }) {
    if (
      field &&
      this.searchSettings &&
      this.searchSettings.searchableFields &&
      (this.searchSettings.searchableFields.indexOf(field) >= 0)
    ) {
      if (this.searchSettings.searchFields) {
        if (this.searchSettings.searchFields.indexOf(field) >= 0) {
          this.searchSettings.searchFields.splice(this.searchSettings.searchFields.indexOf(field), 1);
          this.searchSettings.filters[field.name] = undefined;
        } else {
          this.searchSettings.searchFields.push(field);
          if (field.isBoolean) {
            this.searchSettings.filters[field.name] = false;
          }
        }
      } else {
        this.searchSettings.searchFields = [field];
        if (field.isBoolean) {
          this.searchSettings.filters[field.name] = false;
        }
      }
    }
  }

  search() {
    if (!this.params.where) {
      this.params.where = {};
    }
    this.searchSettings.searchableFields.forEach(field => {
      this.params.where[field.name] = field.defaultValue || undefined;
    });
    console.log(this.searchSettings);
    const searchQuery = Object.keys(this.searchSettings.filters || {})
      .reduce((query, name) => {
        const field = this.searchSettings.searchableFields
            .filter(f => {
              return f.name === name;
            })[0];
        if ((this.searchSettings.filters[name] || this.searchSettings.filters[name] === false) && (!this.searchSettings.filters[name].trim || (this.searchSettings.filters[name].trim() !== ''))) {
          if (field.options) {
            query[name] = (field.options[this.searchSettings.filters[name]] === '--null--') ? null : field.options[this.searchSettings.filters[name]];
          } else if (field.isBoolean) {

            query[name] = !!this.searchSettings.filters[name];
          } else {
            query[name] = (field.exact || field.optionsFunction) ? (
                (this.searchSettings.filters[name] === '--null--') ? null : this.searchSettings.filters[name]
              ) :
              {
                like: (field.wildcard ? '%' : '') + this.searchSettings.filters[name] + '%',
                options: 'i'
              };
          }
        }
        return query;
      }, {});
    this.params.where = {
      ...this.params.where,
      ...searchQuery
    };
    this.submit();
  }

  constructor() { }
  ngOnInit() { }
}
